import React from 'react';
import { useParams } from 'react-router';

// Components
import CommentsListItem from 'Shared/components/Comments/CommentListItem';

// Styles
import './SnapshotComments.scss';

type Props = {
  comments?;
};

const SnapshotComments = ({ comments }: Props) => {
  const { workspaceId } = useParams();
  const baseClassName = 'SnapshotComments';

  return (
    <div className={baseClassName}>
      <p className={`${baseClassName}__title`}>Notes</p>
      {comments.map(comment => (
        <div key={comment.id} className={`${baseClassName}__comment`}>
          <CommentsListItem comment={comment} workspaceId={workspaceId} key={comment.id} />
        </div>
      ))}
    </div>
  );
};

export default SnapshotComments;
